/**
 * Returns the full CSIB, vertical model included, so feature heights can be converted
 * to scene elevations. The vertical model is either a geoid (needs its .ggf among the
 * geodata files) or a site-calibration vertical adjustment carried in the CSIB itself.
 */
export function getVerticalTglDefFromCsib(
  csib64: string
): ArrayBuffer | undefined {
  const trimmed = csib64.trim();
  if (!trimmed) {
    return undefined;
  }
  return Uint8Array.from(atob(trimmed), (c) => c.charCodeAt(0)).buffer;
}
